/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Recentactivity_Title1Inputs */

const he_dashboard_recentactivity_title1 = /** @type {(inputs: Dashboard_Recentactivity_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פעילות אחרונה`)
};

const en_dashboard_recentactivity_title1 = /** @type {(inputs: Dashboard_Recentactivity_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent Activity`)
};

/**
* | output |
* | --- |
* | "Recent Activity" |
*
* @param {Dashboard_Recentactivity_Title1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const dashboard_recentactivity_title1 = /** @type {((inputs?: Dashboard_Recentactivity_Title1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Recentactivity_Title1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_recentactivity_title1(inputs)
	return en_dashboard_recentactivity_title1(inputs)
});
export { dashboard_recentactivity_title1 as "dashboard_recentActivity_title" }